import { createContext, useContext } from 'react'

export type MapControlsSide = 'left' | 'right'

/**
 * Which edge of the map the control rail hugs, for the buttons rendered in its
 * `extraButtons` slot. A dropdown opened from one of them has to grow toward
 * the rail's edge, as the Layers panel does: on the right rail a menu that
 * grows to the right runs off the map.
 */
export const MapControlsSideContext = createContext<MapControlsSide>('left')

export const useMapControlsSide = () => useContext(MapControlsSideContext)

/**
 * z-index for a dropdown opened from the rail.
 *
 * pace's ActionMenu portals to `document.body` at 9999. The route builder's
 * modals (vehicle monitoring's Assign Trip, the save dialog) put their backdrop
 * at 10001, so a menu at the default opens hidden behind the modal its map is
 * in. One above, like the waypoint drag overlay.
 */
export const MAP_CONTROLS_MENU_Z_INDEX = 10002
